import {useEffect} from "react";
import {useDispatch} from "react-redux";

import UserRoutes from "./UserRoutes";
import GoogleAnalytics from "./shared/analytics/GoogleAnalytics.jsx";
import TemplateSelector from "./shared/components/TemplateSelector";

import {current} from "./redux/auth/auth-operations";

import "./shared/styles/style.scss";

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(current());
    }, [dispatch]);

    return (
        <>
            <GoogleAnalytics/>
            <UserRoutes/>
            <TemplateSelector/>
        </>
    );
}

export default App;